export default __webpack_public_path__ + "images/W6.7547cbb.png";